module.exports = __webpack_public_path__ + "static/media/epass.ef52da8c.png";